export async function requestJson(path, { signal, ...options } = {}) {
  const controller = new AbortController();
  const abort = () => controller.abort();
  if (signal?.aborted) abort();
  signal?.addEventListener('abort', abort);
  const timeout = setTimeout(abort, 30000);
  try {
    const response = await fetch(`https://api.stitchtechsolutions.com/api/${path}`, {
      ...options, signal: controller.signal, cache: 'no-store'
    });
    if (!response.ok) throw new Error('The server could not load your data. Please retry.');
    return await response.json();
  } finally {
    clearTimeout(timeout);
    signal?.removeEventListener('abort', abort);
  }
}
